import { SITE } from "@/lib/config";
import { trackEvent } from "@/lib/analytics";
import { useLang } from "@/lib/i18n";
import { cn } from "@/lib/utils";

const base = "inline-flex items-center justify-center gap-2 rounded-full font-medium transition-[background-color,transform,box-shadow] duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hacienda-terracotta";

export const variants = {
  primary: "bg-hacienda-terracotta hover:bg-hacienda-terracotta-dark text-white shadow-md hover:-translate-y-0.5",
  light: "bg-white text-hacienda-terracotta hover:bg-hacienda-cream shadow-md hover:-translate-y-0.5",
  outline: "border-2 border-hacienda-terracotta text-hacienda-terracotta hover:bg-hacienda-terracotta hover:text-white",
  outlineLight: "border-2 border-white text-white hover:bg-white hover:text-hacienda-charcoal",
  ghost: "text-hacienda-terracotta hover:underline underline-offset-4",
};

export const sizes = { sm: "px-5 py-2 text-sm", md: "px-7 py-3 text-base", lg: "px-9 py-4 text-lg" };

// External tracked link (order, call, text, directions, app store)
export const TrackedLink = ({ href, event, params, children, className, variant = "primary", size = "md", external = true, ...rest }) => (
  <a
    href={href}
    onClick={() => trackEvent(event, params)}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className={cn(base, variants[variant], sizes[size], className)}
    {...rest}
  >
    {children}
  </a>
);

export const OrderButton = ({ location, label, className, variant = "primary", size = "md", ...rest }) => {
  const { t } = useLang();
  return (
    <TrackedLink href={SITE.orderUrl} event="order_click" params={{ location }} className={className} variant={variant} size={size} {...rest}>
      {label || t("actions.order")}
    </TrackedLink>
  );
};

export const CallLink = ({ location, children, className, variant = "outline", size = "md", ...rest }) => (
  <TrackedLink href={`tel:${SITE.phoneE164}`} event="phone_click" params={{ location }} external={false} className={className} variant={variant} size={size} {...rest}>
    {children}
  </TrackedLink>
);

export const TextLink = ({ location, children, className, variant = "outline", size = "md", ...rest }) => (
  <TrackedLink href={`sms:${SITE.phoneE164}`} event="text_click" params={{ location }} external={false} className={className} variant={variant} size={size} {...rest}>
    {children}
  </TrackedLink>
);

export const DirectionsLink = ({ location, children, className, variant = "outline", size = "md", ...rest }) => (
  <TrackedLink href={SITE.directionsUrl} event="directions_click" params={{ location }} className={className} variant={variant} size={size} {...rest}>
    {children}
  </TrackedLink>
);
